import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid2 as Grid,
  CircularProgress,
  ListItemButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ListIcon from "@mui/icons-material/List";
import { ExpandMore } from "@mui/icons-material";
import { useQuery } from "react-query";
import { Stack } from "@mui/material";
import { fetchLists } from "./listService";
import { useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import { matchPath } from "react-router-dom";

const TextPrimaryListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

function Navigation() {
  const { isLoading, error, data: lists } = useQuery({
    queryKey: ["lists"],
    queryFn: fetchLists,
  });
  const anchorRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();

  const open = Boolean(anchorEl);

  const handleOpen = () => {
    setAnchorEl(anchorRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isLoading) return <CircularProgress />;
  if (error) {
    console.error("Failed to fetch product lists:", error);
    return null;
  }

  // Match route titles
  const routeTitles = {
    "/lists/search": "Új kereső",
    "/lists": "Listáim",
  };

  let title = routeTitles[location.pathname] || "";

  // Extract parameters using matchPath
  const matchProductListId = matchPath(
    { path: "/lists/:productListId/swipe" },
    location.pathname
  );
  const matchListId = matchPath({ path: "/lists/:id" }, location.pathname);

  const productListId = matchProductListId?.params?.productListId;
  const id = matchListId?.params?.id;

  // Handle dynamic list titles
  const listId = id || productListId;
  if (listId && !title) {
    const matchingList = lists.find((list) => list.id === listId);
    title = matchingList ? matchingList.name : "Lista";
  }

  // Determine active list item
  const isSearchActive =
    location.pathname === "/lists/search" ||
    matchPath({ path: "/lists/:productListId/swipe" }, location.pathname);

  const isListsActive =
    !isSearchActive &&
    (
        location.pathname === "/lists" ||
        matchPath({ path: "/lists/:id" }, location.pathname)
    );

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      sx={{ pl: 4, pr: 4, borderRadius: "8px", bgcolor: "primary.main" }}
    >
      <Grid xs={12} sm={8}>
        <Typography color="textSecondary" variant="h5">
          {title}
        </Typography>
      </Grid>
      <Grid xs={12} sm={4} sx={{ml: "auto"}}>
        <List component={Stack} direction="row" >
          <ListItem component={Link} to="/lists/search">
            <TextPrimaryListItemIcon>
              <SearchIcon sx={{ color: "textPrimary" }} />
            </TextPrimaryListItemIcon>
            <ListItemText
              primary="Keresés"
              primaryTypographyProps={{
                color: "textSecondary",
                fontWeight: isSearchActive ? "bold" : "normal",
              }}
            />
          </ListItem>
          <ListItem component={Link} to="/lists">
            <TextPrimaryListItemIcon>
              <ListIcon />
            </TextPrimaryListItemIcon>
            <ListItemText
              primary="Listáim"
              primaryTypographyProps={{
                color: "textSecondary",
                fontWeight: isListsActive ? "bold" : "normal",
              }}
            />
          </ListItem>
          <ListItemButton onClick={handleOpen} ref={anchorRef}>
            <TextPrimaryListItemIcon>
              <ExpandMore />
            </TextPrimaryListItemIcon>
          </ListItemButton>
          <Menu
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            onClose={handleClose}
            disablePortal
          >
            {lists.map((list) => (
              <MenuItem
                key={list.id}
                onClick={handleClose}
                component={Link}
                to={`lists/${list.id}`}
              >
                {list.name}
              </MenuItem>
            ))}
          </Menu>
        </List>
      </Grid>
    </Grid>
  );
}

export default Navigation;
